'use client';

import * as React from 'react';
import { useAppSelector } from '@/store/hooks';
import { getDrawerContent } from '@/store/reducers/drawer-content-slice';
import { User } from '@alien-platform/bo-sdk-v2';
import { useColorScheme } from '@mui/material';

import JsonView from '@/components/core/json-view';

export function JsonTab({ userData }: { userData: User | null }): React.JSX.Element | null {
  const { colorScheme } = useColorScheme();

  const { STAFF_DETAILS: data } = useAppSelector(getDrawerContent);

  return data ? <JsonView src={data} theme={colorScheme === 'dark' ? 'monokai' : 'bright:inverted'} /> : null;
}
